import React from 'react';
import './Home.css'; // Add your styling here
import heroImage from '../Assets/techBanner.png'; // Adjust the path to where your image is stored

const Home = () => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <img src={heroImage} alt="Hero Banner" className="hero-image" />
        <h1>Welcome to LogicBunny Technology</h1>
        <a href="#services" className="cta-button">Discover Our Services</a>
      </section>

      {/* Introduction */}
      <section className="intro-section">
        <h2>About Us</h2>
        <p style={{textAlign:"center"}}>We are a leading technology firm specializing in web and mobile solutions. Our mission is to drive digital transformation and success for our clients.</p>
      </section>

     <section className="services-section" id="services">
  <h2 style={{color:"#152d5f"}}>Our Services</h2>
  <p className="services-intro">
    At LogicBunny Technology, we specialize in crafting high-quality digital solutions tailored 
    to your business needs. With a focus on innovation and excellence, we ensure that our 
    clients stay ahead in the ever-evolving digital world.
  </p>

  <div className="services-grid">
    <div className="service-card">
      <h3>Web Development</h3>
      <p>
        We create dynamic, scalable, and responsive websites that not only look great but also 
        provide a seamless user experience. Our expert team ensures that every website is optimized 
        for speed, security, and usability.
      </p>
      <ul>
        <li>Custom-built websites tailored to your brand</li>
        <li>SEO-friendly architecture for better visibility</li>
        <li>Optimized for all devices, ensuring a great user experience</li>
      </ul>
    </div>

    <div className="service-card">
      <h3>Mobile App Development</h3>
      <p>
        Our team develops engaging and feature-rich mobile applications for both iOS and Android, 
        ensuring smooth performance and user-friendly interfaces. Whether it's a startup app or 
        an enterprise-level solution, we've got you covered.
      </p>
      <ul>
        <li>High-performance and feature-rich mobile applications</li>
        <li>Intuitive and engaging UI/UX for an exceptional experience</li>
        <li>Seamless integration with third-party APIs and services</li>
      </ul>
    </div>

    <div className="service-card">
      <h3>Game Development</h3>
      <p>
        Our game development services bring immersive and interactive gaming experiences to life. 
        With expertise in various game engines, we create engaging gameplay with rich graphics 
        and fluid mechanics.
      </p>
      <ul>
        <li>Innovative game mechanics and smooth animations</li>
        <li>Multi-platform support for mobile and web gaming</li>
        <li>Robust backend for real-time multiplayer experiences</li>
      </ul>
    </div>

    <div className="service-card">
      <h3>IT Consulting</h3>
      <p>
        We provide expert IT consulting services to help businesses leverage technology 
        effectively. Our goal is to improve efficiency, streamline operations, and ensure 
        a future-proof digital infrastructure.
      </p>
      <ul>
        <li>Custom technology solutions tailored to your business</li>
        <li>Security and infrastructure assessments</li>
        <li>Guidance on emerging tech trends and best practices</li>
      </ul>
    </div>
  </div>
</section>


<section className="portfolio-section">
  <h2 className="section-title">✨ Featured Projects</h2>
  <p className="portfolio-intro" >
    Explore our latest cutting-edge projects, designed with innovation and precision. 
    Each project showcases our expertise in building dynamic and engaging digital experiences.
  </p>

  <div className="portfolio-grid">
    <div className="project-card">
      <h3 className="project-title" style={{color:"#0ec6d5"}}>🃏 Rummy Game</h3>
      <p className="project-overview">
        <strong>Overview:</strong> A real-time <strong>multiplayer Rummy game</strong> that delivers a seamless and immersive gaming experience. Designed with <strong>cutting-edge technology</strong>, it ensures smooth gameplay, fair competition, and an intuitive user interface. The game supports <strong>multiple Rummy formats</strong>, allowing players to choose their preferred style and compete in thrilling matches against real opponents.
      </p>
      <ul className="project-features" style={{color:"#F8F9FA"}}>
        <li>⚡ <strong>Real-time gameplay</strong> with smooth animations.</li>
        <li>🔒 <strong>Robust anti-cheating mechanisms</strong> to ensure fair play.</li>
        <li>📱 <strong>Cross-platform support</strong> for web and mobile devices.</li>
        <li>🤖 <strong>AI-powered opponent matchmaking</strong> for balanced games.</li>
        <li>💬 <strong>Multiplayer chat & social features</strong> to connect with players.</li>
        <li>🎭 <strong>Customizable game rooms & private tables</strong> for private matches.</li>
        <li>🏆 <strong>Leaderboards & Rewards System</strong> with in-game bonuses.</li>
        <li>🎨 <strong>Intuitive UI & immersive graphics</strong> for enhanced gameplay.</li>
      </ul>
    </div>
  </div>
</section>



      {/* Testimonials */}
      <section className="testimonials-section">
        <h2>What Our Clients Say</h2>
        <div className="testimonials">
          <blockquote>
            "LogicBunny Technology exceeded our expectations with their innovative solutions and exceptional service."
            <footer> ~Sandeep</footer>
          </blockquote>
          {/* Add more testimonials here */}
        </div>
      </section>
    </div>
  );
};

export default Home;
